import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getSubmission } from '../api/client.js';
import Celebration from '../components/Celebration.jsx';
import Layout from '../components/Layout.jsx';
import SubmissionDetail from '../components/SubmissionDetail.jsx';

export default function SubmissionDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submission, setSubmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [celebrate, setCelebrate] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    getSubmission(id)
      .then((s) => {
        if (!cancelled) setSubmission(s);
      })
      .catch((e) => {
        if (!cancelled) setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <Layout title="Submission Detail">
      <div className="detail-page__back">
        <button className="btn btn--ghost" onClick={() => navigate(-1)}>
          ← Back to dashboard
        </button>
      </div>

      {loading && (
        <div className="card">
          <div className="card__body">
            <div className="skeleton-cell" style={{ width: '40%', marginBottom: 12 }} />
            <div className="skeleton-cell" style={{ width: '80%', marginBottom: 8 }} />
            <div className="skeleton-cell" style={{ width: '70%' }} />
          </div>
        </div>
      )}

      {error && !loading && <div className="form-error">{error}</div>}

      {submission && !loading && (
        <SubmissionDetail
          submission={submission}
          onChange={setSubmission}
          onResolvedTransition={() => setCelebrate(true)}
        />
      )}

      <Celebration active={celebrate} onDone={() => setCelebrate(false)} />
    </Layout>
  );
}
